import { render, staticRenderFns } from "./GameplaySport.vue?vue&type=template&id=3095f029&"
import script from "./GameplaySport.vue?vue&type=script&lang=js&"
export * from "./GameplaySport.vue?vue&type=script&lang=js&"
import style0 from "./GameplaySport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports